import React, { useState, useEffect } from 'react'
import Container from '@mui/material/Container'
import { Button, Box } from '@mui/material'
import fetchData from '../assets/data'; 
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import { Link } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import useMediaQuery from "@mui/material/useMediaQuery";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../components/Config';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import axios from 'axios'; 
import Cookies from 'js-cookie';


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}
CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
const PaymentDetails = () => {
  const { paymenId } = useParams();
  const { id } = useParams();

  const [findMorcards, setFindMorCards] = useState([]);


  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [read, setRead] = useState(false)
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [axpended, setaxpended] = useState(false);

  const handelCards = () => {
    setaxpended(!axpended)
  }
  const match1990 = useMediaQuery("(max-width:450px)");
  const checkEidth = window.innerWidth

  const { enqueueSnackbar } = useSnackbar();
  const [account_holder_name, setaccount_holder_name] = useState("");
  const [bank_account_number, setbank_account_number] = useState("");
  const [sort_code, setsort_code] = useState("");
  const [has_gas_boiler, sethas_gas_boiler] = useState(false);
  const [accept_terms, setaccept_terms] = useState(false);
  const [receive_news_and_offers, setreceive_news_and_offers] = useState(false);
  const navigate = useNavigate();



  const simulateAPIRequest = async (url, method, data, paymenId, id) => {
    try {
      const token = Cookies.get('token');
      const response = await axios({
        method,
        url,
        data,
        headers: {
          Authorization: `Bearer ${token}` 
        }
      });
        return response;
        } catch (error) {
          if (error.response && error.response.data && error.response.data.message) {
              enqueueSnackbar(error.response.data.message, { variant: 'error' });
          } else {
              enqueueSnackbar('An error occurred', { variant: 'error' });              
          }
        }
    };

  const handlepaymentDetail = async (account_holder_name, bank_account_number, sort_code, has_gas_boiler, accept_terms, receive_news_and_offers, paymenId, id) => {
    if (!account_holder_name || !bank_account_number || !sort_code || !has_gas_boiler || !accept_terms ) {
      enqueueSnackbar('Please fill in all fields', { variant: 'error' });


      return paymenId, id;
    }
    
    const url = `${API_BASE_URL}/plans/details/${paymenId}/`;
    const method = 'PUT';
    const data = {
      account_holder_name: account_holder_name,
      bank_account_number: bank_account_number,
      sort_code: sort_code,
      accept_terms: accept_terms,
      has_gas_boiler: has_gas_boiler,
      receive_news_and_offers: receive_news_and_offers,
    };
    
    try {
      await simulateAPIRequest(url, method, data, paymenId, id);
      enqueueSnackbar('Details saved successfully', { variant: 'success' });
      // navigate(`/SetupDirectDebit/${paymenId}/${id}`);
      navigate(`/`);

    } catch (error) {
      enqueueSnackbar('Failed to save details', { variant: 'error' });
      
      
    }
  };
  

  const handleAccountHolderName = (e) => {
    setaccount_holder_name(e.target.value);
  };
  
  const handleBankAccountNumber = (e) => {
    setbank_account_number(e.target.value);
  };
  
  const handleDocumentDownload = async () => {
    try {
      const url = `${API_BASE_URL}/customer/document/`; 
      const response = await axios({
        method: 'GET',
        url,
        responseType: 'blob', 
      });
  
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'Terms&Conditions.pdf'; 
  
      if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
        }
      }
  
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const downloadUrl = window.URL.createObjectURL(blob);
  
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', filename); 
      document.body.appendChild(link);
      
      link.click();
      
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Failed to download document:', error);
      enqueueSnackbar('Failed to download document', { variant: 'error' });
    }
  };
  const handleSortCode = (e) => {
    setsort_code(e.target.value);
  };
  
  const handleHasGasBoiler = (e) => {
    sethas_gas_boiler(e.target.checked);
  };
  
  const handleAcceptTerms = (e) => {
    setaccept_terms(e.target.checked);
  };
  
  const handleNewsandOffers = (e) => {
    setreceive_news_and_offers(e.target.checked)
  };

  useEffect(() => {
    fetchData(id, setFindMorCards);
  }, [id]);
  


  useEffect(() => {
    if (checkEidth <= 450) {
      setaxpended(true)
    }
  }, [checkEidth])


  return (
    <Container maxWidth="xl">
      <div className='main_div_find'>

        <div className="box_one_find" style={{ height: "fit-content" }}>
          <div className='check_stp1'>
            <p>Step 2 of 2</p>
            <h1>Payment Details</h1>
            <form className='form_dabits'>
              <div>
                <label htmlFor="1">Name of Account Holder</label>
                <input type="text" id='1' placeholder='First Name' onChange={handleAccountHolderName}/>
              </div>
              <div>
                <label htmlFor="2">Bank Account Number</label>
                <input type="text" placeholder='Bank Account Number' id='2' onChange={handleBankAccountNumber}/>
              </div>
              <div>
                <label htmlFor="3">Sort Code</label>
                <input type="text" placeholder='Sort Code' id='3' onChange={handleSortCode}/>
              </div>

            </form>
              <div className="labl_div_pay">
                <h1 className='m-0 cons_h1'>Consent</h1>
                <label className="container">I confirm I have a gas boiler. It is connected to mains gas and in good working order( required)
                  <input type="checkbox" onChange={handleHasGasBoiler}/>
                  <span className="checkmark"></span>
                </label>
                <label className="container">I accept the Wecare Terms of <Link to="/Terms" className='term_and_Agre'>Service Agreement (required)</Link>
                  <input type="checkbox" onChange={handleAcceptTerms} />
                  <span className="checkmark"></span>
                </label>
                <label className="container">Tick this box if you want to occasionally receive news and offers from us. We won’t spam     you, and you can unsubscribe at any time
                  <input type="checkbox" onChange={handleNewsandOffers}/>
                  <span className="checkmark"></span>
                </label>
                <Button variant="contained" className='paymint_btn anka_tag'
                onClick={() => handlepaymentDetail(account_holder_name, bank_account_number, sort_code, has_gas_boiler, accept_terms, receive_news_and_offers, paymenId, id)}
                >
                  Set Up Debit Payment
                </Button>
              </div>


          </div>
        </div>

        <div className="box_celected_plans" style={{ height: axpended ? "150px" : "auto" }}>
          {axpended ? (<IconButton className='icons_expended'
            onClick={handelCards}>
            <ArrowBackIosRoundedIcon />
          </IconButton>) : null}
          {findMorcards.map((item, i) => (
              <div key={i}>
                <div className="selected_plan_div">
                  <span>
                    <p>{item?.sel}</p>
                    <h1>{item?.title}</h1>
                    <p className="m-0">{item?.ser}</p>
                  </span>
                  <img src={item?.img} alt="icons" />
                </div>
                <div className="cards_actions mt">
                  <div className="cards_actions">
                    {item?.working.map((item, i) => (
                      <div className="working" key={i}>
                        <CheckCircleOutlineRoundedIcon className="iconmark" />{item}
                      </div>
                    ))}
                  </div>
                  <div className="cards_actions">
                    {item?.notworking?.map((item, i) => (
                      <div className="notwarking" key={i}>
                        <CancelOutlinedIcon className="notwar" />
                        <span className="spanundesr">{item}</span>
                      </div>
                    ))}
                  </div>
                  <div className="view_div">
                    <p>
                      Review what is covered in your WeCare policy, and what is not.{' '}
                      <span onClick={handleOpen}>View here</span>
                    </p>
                    <Modal
                      open={open}
                      onClose={handleClose}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                    >
                      <div className="modal_find">
                        <div className="find_close">
                          <IconButton>
                            <CloseIcon onClick={handleClose} />
                          </IconButton>
                        </div>
                        <div>
                          <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="basic ta bs example"
                            className="main_tabs"
                          >
                            <Tab label="Covered" {...a11yProps(0)} className="tabeBtn" />
                            <Tab label="Not Covered" {...a11yProps(1)} className="tabeBtn" />
                          </Tabs>
                        </div>
                        <div className="find_tabs">
                          <CustomTabPanel value={value} index={0}>
                            <div className="cards_actions">
                              {item?.working.map((item, i) => (
                                <div className="working" key={i}>
                                  <CheckCircleOutlineRoundedIcon className="iconmark" /> {item}
                                </div>
                              ))}
                            </div>
                          </CustomTabPanel>
                          <CustomTabPanel value={value} index={1}>
                            <div className="cards_actions">
                              {item?.notworking.map((item, i) => (
                                <div className="notwarking" key={i}>
                                  <CancelOutlinedIcon className="notwar" /> {item}
                                </div>
                              ))}
                            </div>
                          </CustomTabPanel>
                        </div>
                        <div className="btnFounds">
                          <Button variant="outlined" onClick={handleDocumentDownload}>Download Terms & Conditions</Button>
                        </div>
                      </div>
                    </Modal>
                  </div>
                </div>
                <div className="month_div">
                  <h1>{item?.month}</h1>
                  <span className="d-flex align-items-baseline">
                    <h2>{item?.price}</h2>p/m
                  </span>
                </div>
                <p className="desc_dabid">
                  The initial direct debit payment will be requested in the upcoming 14 days. Your policy agreement spans a duration of 12 months.
                  {read || <span className="read_btn" onClick={() => setRead(true)}>Read More</span>}
                </p>
                {read && (
                  <div className="read_more">
                    <p className="reading">
                      We will reach out to you well in advance of your agreement renewal date. Your agreement is set to renew automatically unless you opt to cancel.
                      This automatic renewal is designed to maintain continuous coverage for you. If you prefer not to proceed with automatic renewal, feel free to
                      get in touch with us to opt out. <span className="read_btn" onClick={() => setRead(false)}>Read Less</span>
                    </p>
                  </div>
                )}
                <div className="month_div">
                  <h1>{item?.serv}</h1>
                  <span className="d-flex align-items-baseline">
                    <h2>{item?.fee}</h2>p/m
                  </span>
                </div>
                <p className="desc_dabid">
                  The service fee is the charge incurred each time you seek a repair. You have the flexibility to select a plan with or without a service request
                  fee. Opting for a higher service request fee lowers your monthly payments.
                </p>
              </div>
            ))}
          <IconButton className='icons_expended_bot' onClick={handelCards}>
            <ArrowBackIosRoundedIcon />
          </IconButton>
        </div>


      </div>
    </Container>
  )
}

export default PaymentDetails
